// extracted by mini-css-extract-plugin
export var faq_list = "faqList-module--faq_list--580e9";